// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const StatusNegativeIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <circle cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2} />
    <path stroke="currentColor" strokeWidth={2} d="M16.5 11.88h-9" />
  </svg>,
  "StatusNegative",
);
export default StatusNegativeIcon;
